(function () {
    'use strict';

    /**
     * CTR Smooth Scroll
     * Handles smooth scrolling for all anchor links
     */

    const CTRSmoothScroll = {
        config: {
            behavior: 'smooth',
            offset: 0 // Additional offset in pixels beyond header
        },

        init() {
            this.bindEvents();
            this.handleInitialHash();
        },

        bindEvents() {
            // Use event delegation for better performance
            document.addEventListener('click', (e) => {
                const anchor = e.target.closest('a[href^="#"]');
                if (!anchor) return;

                const href = anchor.getAttribute('href');
                
                // Skip if it's just "#" or empty
                if (!href || href === '#') return;

                // Skip if it has data-no-smooth-scroll attribute
                if (anchor.hasAttribute('data-no-smooth-scroll')) return;

                const targetId = href.slice(1);
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    e.preventDefault();
                    this.scrollToElement(targetElement);
                    
                    // Update URL hash without jumping
                    history.pushState(null, null, href);
                }
            });

            // Handle browser back/forward with hash changes
            window.addEventListener('hashchange', () => {
                const hash = window.location.hash;
                if (hash) {
                    const targetElement = document.getElementById(hash.slice(1));
                    if (targetElement) {
                        this.scrollToElement(targetElement);
                    }
                }
            });
        },

        handleInitialHash() {
            // Handle page load with hash in URL
            const hash = window.location.hash;
            if (hash) {
                // Small delay to ensure page is ready
                requestAnimationFrame(() => {
                    const targetElement = document.getElementById(hash.slice(1));
                    if (targetElement) {
                        // Prevent default jump
                        window.scrollTo(0, 0);
                        // Then smooth scroll
                        setTimeout(() => {
                            this.scrollToElement(targetElement);
                        }, 100);
                    }
                });
            }
        },

        scrollToElement(element) {
            const headerOffset = this.getHeaderOffset();
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset - this.config.offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: this.config.behavior
            });

            // Set focus for accessibility
            element.setAttribute('tabindex', '-1');
            element.focus({ preventScroll: true });
        },

        getHeaderOffset() {
            // Use --header-height CSS variable if available (set by theme)
            const headerHeightVar = getComputedStyle(document.documentElement)
                .getPropertyValue('--header-height')
                .trim();
            
            if (headerHeightVar) {
                const parsed = parseInt(headerHeightVar.replace('px', ''), 10);
                if (!isNaN(parsed)) {
                    return parsed;
                }
            }

            // Fallback: check for sticky/fixed header
            const header = document.querySelector('.header, header, .shopify-section-header, [data-sticky-header]');
            if (header) {
                const style = window.getComputedStyle(header);
                if (style.position === 'fixed' || style.position === 'sticky') {
                    return header.offsetHeight;
                }
            }
            
            return 0;
        },

        // Public method to scroll to a target programmatically
        scrollTo(target) {
            const element = typeof target === 'string' 
                ? document.getElementById(target.replace('#', ''))
                : target;
            
            if (element) {
                this.scrollToElement(element);
            }
        }
    };

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => CTRSmoothScroll.init());
    } else {
        CTRSmoothScroll.init();
    }

    // Expose globally for programmatic use
    window.CTRSmoothScroll = CTRSmoothScroll;
})();
